export class Zona {
    n?:string;
    id?:string;
    idzona?:any;
    descripcion?:string;
    otro?:string;
    fechareg?:string;
    fechamod?:string;
    activo?:string;
    usuario_id?:string;
}
 